import styled, { keyframes } from 'styled-components';
import { ThemeColours } from '../../styles/ThemeColours';

export const LoadingSpinnerView = styled.div`
  color: ${ThemeColours.primary};
  display: flex;
  height: 100vh;
  overflow: hidden;
  width: 100%;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
`;

export const Spinner = styled.svg`
  animation: ${spin} 1.5s infinite ease;
  height: 64px;
  margin: auto auto;
  width: 64px;
`;

export const Fidget = styled(Spinner)`
  animation: ${spin} 0.5s infinite linear;
`;

export const HighlightPath = styled.path`
  fill: currentColor;
`;

export const RingPath = styled.path`
  color: ${ThemeColours.mono300};
  fill: currentColor;
`;
